import { CategoriesSidebar } from '@components/blog/CategoriesSidebar'
import { RecentPost } from '@components/blog/RecentPost'
import SearchPost from '@components/blog/SearchPost'
import s from '@pagestyles/Blog.module.scss'
import { useTranslation } from 'react-i18next'
import type { Maybe } from '@pylot-data/pylotschema'
import {
    CMSBlockValueGet,
    CMSConfigConst,
    getCMSBlock
} from '@components/common/CMSBlockConst/cms-block-util'
import { CmsBlock } from '@pylot-data/fwrdschema'
import { RichContent } from '@corratech/pylot-rich-content'
import DateWisePostFilter from '@components/blog/DateWisePostFilter'

const Sidebar = (): JSX.Element => {
    const dataCms:
        | Maybe<Array<Maybe<CmsBlock>>>
        | undefined = CMSBlockValueGet()

    const { t } = useTranslation(['blog'])

    return (
        <div className={s['sideBar']}>
            <SearchPost />
            <h2>{t('Categories')}</h2>
            <CategoriesSidebar />
            <DateWisePostFilter />
            <RecentPost />
            <div className={s['aboutBanner']}>
                <RichContent
                    html={getCMSBlock(CMSConfigConst.ABOUT_INFO, dataCms)}
                />
            </div>
        </div>
    )
}

export default Sidebar
